<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='#'>{{ translations('navbar.return_management') }}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-replacement'>{{ translations('replacement.archive_replacement') }}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{ translations('replacement.new_replacement_processing') }}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>{{ translations('replacement.processing_date') }}</th>
                <td>
                  <button
                    ref='info06'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info06'
                    data-placement='right'
                  >{{ replacementInfo.processed_at ? $invoiceTools.formatDate(replacementInfo.processed_at) : '----------'}}</button>
                  <div id='popover-info06' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('replacement.processing_date') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='date' v-model='tempInfo.processed_at' class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('processed_at',tempInfo.processed_at,'info06')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{ translations('common.update') }}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('replacement.organization_number') }}</th>
                <td>
                  <button
                    ref='info02'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info02'
                    data-placement='right'
                  >{{ replacementInfo.reference_number ? replacementInfo.reference_number : '----------'}}</button>
                  <div id='popover-info02' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('replacement.organization_number') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <input ref='input-info02' type='text' v-model='tempInfo.reference_number' class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('reference_number',tempInfo.reference_number,'info02')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{ translations('common.update') }}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('replacement.remarks') }}</th>
                <td>
                  <button ref="info10" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info10' data-placement='right'>{{ replacementInfo.memo ? replacementInfo.memo : '--------------' }}</button>
                  <div id='popover-info10' class='popover popover-x popover-default'>
                      <div class='arrow'></div>
                      <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('replacement.remarks') }}</div>
                      <div class='popover-body popover-content'>
                          <textarea class="form-control" v-model="tempInfo.memo"></textarea>
                      </div>
                      <div class='popover-footer'>
                          <button type='submit' v-on:click="updateField('memo', tempInfo.memo, 'info10')" class='btn btn-sm btn-primary'>{{ translations('common.update') }}</button>
                      </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <hr>
          <div class='form-inline'>
            <div class='form-group'>
              <a class='btn btn-link btn-sm text-danger' href='#'>{{ translations('common.delete') }}</a>
            </div>
          </div>
          <hr>
          <div>
            <h5 class='mb-3'>Check list</h5>
            <div class='padding-inline-start-5px'>
              <div>◎{{translations('replacement.best_condition')}}
                <ul class='margin-bottom-10px'>
                  <li>{{translations('replacement.sealed_item')}}</li>
                </ul>
              </div>
              <div>○{{ translations('replacement.good_condition') }}
                <ul class='margin-bottom-10px'>
                  <li>{{ translations('replacement.unopened_unused') }}</li>
                </ul>
              </div>
              <div>△{{translations('replacement.usable')}}
                <ul class='margin-bottom-10px'>
                  <li>{{ translations('replacement.functional_item') }}</li>
                </ul>
              </div>
              <div>×{{ translations('replacement.not_usable') }}
                <ul class='margin-bottom-10px'>
                  <li>{{ translations('replacement.immovable_damaged') }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class='right-container'>
          <div class="form-inline justify-content-end"><!-- VAT -->
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value="" id="defaultCheckTax" ref="defaultCheckTax" v-model="taxIncluded" @change="toggleTax()">
              <label class="form-check-label" for="defaultCheckTax">{{ translations('common.tax_included') }}</label>
            </div>
          </div>
          <div class='table-scroll mb-4'>
            <table class='table table-sm table-striped table-1500 table-align-middle'>
              <thead>
                <tr>
                  <th></th>
                  <th>{{ translations('replacement.replacement_status') }}</th>
                  <th>{{ translations('replacement.receiving_warehouse') }}</th>
                  <th>{{ translations('replacement.shipping_warehouse') }}</th>
                  <th>{{ translations('replacement.reason_return') }}</th>
                  <th>{{ translations('replacement.operation_confirmation') }}</th>
                  <th>{{ translations('replacement.verification_results') }}</th>
                  <th>{{ translations('replacement.model_number') }}</th>
                  <th>{{ translations('replacement.number_item') }}</th>
                  <th class="width-50-px">{{ translations('replacement.unit_price') }}</th>
                  <th class="width-50-px"></th>
                  <th>{{ translations('replacement.original_unit_price') }}</th>
                  <th>{{ translations('replacement.summary') }}</th>
                  <th>{{ translations('replacement.unit_price_total') }}</th>
                  <th>{{ translations('replacement.total_liabilities') }}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-for='(detail, i) in replacementDetails'>
                  <tr :key='i'>
                    <td>
                      <button @click="deleteDetail(i)" class='btn-change minus'><i></i></button>
                    </td>
                    <td>{{ getRetrunPropsById(replacement_statuses, detail.replacement_status_id, 'name') }}</td>
                    <td>―</td>
                    <td>―</td>
                    <td>
                      <button type='button' class='btn btn-link p-0' data-toggle='popover-x' :data-target="'#popover-reason' + i" data-placement='right'>
                        {{ (detail.replacement_reason_id) ? getRetrunPropsById(replacement_reasons, detail.replacement_reason_id, 'name') : '-------------' }}
                      </button>
                      <div :ref="'reason' + i" :id="'popover-reason' + i" class='popover popover-x popover-default'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>返品理由</div>
                        <div class='popover-body popover-content'>
                          <select v-model="tempDetail[i].replacement_reason_id" class="custom-select">
                            <template v-for="(reason, i) in replacement_reasons">
                              <!-- 破棄済以外 -->
                              <option :key="i" :value="reason.id">{{ reason.name }}</option>
                            </template>
                          </select>
                        </div>
                        <div class='popover-footer'>
                          <button @click="updateField('replacement_reason_id', tempDetail[i].replacement_reason_id, ('reason' + i), detail)" type='submit' class='btn btn-sm btn-primary'>更新</button>
                        </div>
                      </div>
                    </td>
                    <td>
                      <button
                        type='button'
                        class='btn btn-link p-0'
                        data-toggle='popover-x'
                        :data-target="'#popover-info0000' + i"
                        data-placement='right'
                      >{{ (detail.replacement_state_id) ? getRetrunPropsById(replacement_states, detail.replacement_state_id, 'name') : '-------------' }}</button>
                      <div :ref="'info0000' + i" :id="'popover-info0000' + i" class='popover popover-default popover-x has-footer'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'>
                          <button class='close' data-dismiss='popover-x'>×</button>動作確認
                        </div>
                        <div class='popover-body popover-content'>
                          <select v-model="tempDetail[i].replacement_state_id" class="custom-select">
                            <template  v-for="(state, i) in replacement_states">
                              <option :key="i" :value="state.id">{{ state.name }}</option>
                            </template>
                          </select>
                        </div>
                        <div class='popover-footer'>
                          <button @click="updateField('replacement_state_id', tempDetail[i].replacement_state_id, ('info0000' + i), detail)" type='submit' class='btn btn-sm btn-primary'>更新</button>
                        </div>
                      </div>
                      <div class='popover-x-marker' style='display: none;'></div>
                    </td>
                    <td>
                      <button
                        type='button'
                        class='btn btn-link p-0'
                        data-toggle='popover-x'
                        :data-target="'#popover-info03' + i"
                        data-placement='right'
                      >{{ detail.test_result ? detail.test_result : '-------------' }}</button>
                      <div :ref="'popover-info03' + i" :id="'popover-info03' + i" class='popover popover-default popover-x has-footer'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'>
                          <button class='close' data-dismiss='popover-x'>×</button>検証結果
                        </div>
                        <div class='popover-body popover-content'>
                          <textarea class='form-control' v-model="tempDetail[i].test_result"></textarea>
                        </div>
                        <div class='popover-footer'>
                          <button @click="updateField('test_result', tempDetail[i].test_result, ('info03' + i), detail)" type='submit' class='btn btn-sm btn-primary'>更新</button>
                        </div>
                      </div>
                      <div class='popover-x-marker' style='display: none;'></div>
                    </td>
                    <td>{{ (typeof detail.type_number === 'number') ? getRetrunPropsById(products, detail.type_number, 'type_number') : detail.type_number }}</td>
                    <td class="right">{{ detail.quantity.toLocaleString() }}</td>
                    <td class="right" v-if="taxIncluded" colspan="2">{{ toVatFormat(detail.unit_price) }}</td>
                    <td v-if="!taxIncluded">
                      <div class="number-container"><!-- input 含む number-container ブロック -->
                        <input type="text" @input="numbers(i,'unit_price')" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.unit_price" :id="'unit_price' + i" @focus="refresh('unit_price')" @blur="refresh('unit_price')"/><!-- 既存の class に number-input 追記、id focus blur 記入 -->
                        <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.unit_price.toLocaleString() }}</span><!-- input 同様の class に number-overlap 追記、style も転記 -->
                      </div>
                    </td>
                    <td class="right" v-if="!taxIncluded">({{Math.round(Number(detail.unit_price) * (100 + Number(vatRate)) / 100).toLocaleString()}})</td>

                    <td class="right">{{ toVatFormat(getRetrunPropsByItemNo(products, detail.item_no, 'row_price'), '0') }}</td>

                    <td class="right"><input type="text" class="form-control form-control-sm" style="width:10em;" v-model="detail.remarks"/></td>

                    <td class="right">{{ toVatFormat(detail.unit_price * detail.quantity, '0') }}</td>
                    <td class="right">{{ detail.replacement_status_id === 1 ? toVatFormat(getRetrunPropsByItemNo(products, detail.item_no, 'row_price') * detail.quantity, '0') : '' }}</td>
                  </tr>
                </template>
                <tr class='bg-lightgreen'>
                  <td>
                    <button @click="openAddDetailModal()" class='btn-change plus' type='button'><i></i></button>
                    <button ref="openAddDetailModal" hidden="true" class='btn-change plus' type='button' data-toggle='modal' data-target='#NewReplacementModal'><i></i></button>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class='font-weight-bold right'>{{ toVatFormat(grandTotalUnitPrice) }}</td>
                  <td class='font-weight-bold right'>{{ toVatFormat(grandTotalDebt) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class='form-inline'>
            <div class='form-group mr-2'>
              <button @click="addReplacement()" class='btn btn-sm btn-primary'>更新</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NewReplacementModal
      :replacementDetails='replacementDetails'
      :replacementStatuses="replacement_statuses"
      :replacementReasons="replacement_reasons"
      :replacementStates="replacement_states"
      :products="products"
      :vat="{taxIncluded:taxIncluded, vatRate:vatRate}"
    />
    <SingleReturnsModal/>
    <vue-element-loading :active="isLoading" :is-full-screen="true"/>
  </div>
</template>

<script>
import $ from 'jquery' // number-container
import VueElementLoading from 'vue-element-loading'
import NewReplacementModal from '@/components/NewReplacementModal'
import SingleReturnsModal from '@/components/SingleReturnModal'
import { mapState } from 'vuex'
export default {
  name: 'NewReplacement',
  props: {},
  components: {
    VueElementLoading,
    NewReplacementModal,
    SingleReturnsModal
  },
  watch: {
    replacementDetails: {
      handler (v) {
        this.tempDetail = v
        setTimeout(() => {
          this.popoverButtons()
          this.getGrandTotal()
        }, 1000)
      },
      deep: true
    },
    'tempInfo.bill_to_id' (newId, oldId) {
      this.updateField('destinations_id', '', 'info04')
      this.listDestinations()
    }
  },
  data () {
    return {
      vatRate: 0, // VAT
      taxIncluded: false, // VAT
      isLoading: false,
      replacementInfo: {},
      replacementDetails: [],
      tempInfo: {},
      tempDetail: [],
      // warehouses: [],
      stores: [],
      bill_to: [],
      destinations: [],
      delivery_destinations: [],
      products: [],
      grandTotalUnitPrice: 0,
      grandTotalDebt: 0
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    replacement_reasons () {
      return this.$store.getters['Return/getReasons']
    },
    replacement_statuses () {
      const statuses = this.$store.getters['Replacement/getStatuses']
      return this.translateStatuses(statuses)
    },
    replacement_states () {
      const states = this.$store.getters['Return/getStates']
      return this.translateStates(states)
    },
    master_mywarehouses () {
      return this.$store.getters['Master/getMywarehouses']
    }
  },
  created () {
    this.isLoading = true
    this.$store.dispatch('Return/checkReasons')
    this.$store.dispatch('Replacement/checkStatuses')
    this.$store.dispatch('Return/checkStates')
    this.$store.dispatch('Master/checkMywarehouses')
    this.getVatRate() // VAT
    this.getSequence()
    if (this.isNewReplacement()) {
      this.setEmptyData()
      setTimeout(() => { this.setReplacementDate() }, 1000)
    } else {
      this.loadReplacementDetails()
    }
    setTimeout(() => {
      this.popoverButtons()
      this.getBillToList()
      // this.getWarehouseList()
    }, 1200)
    setTimeout(() => { this.isLoading = false }, 3000)
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    translateStatuses (statuses) {
      return statuses.map(statuse => ({
        ...statuse,
        name: this.translations(`statuses_replacement.${statuse.name}`)
      }))
    },
    translateStates (states) {
      return states.map(state => ({
        ...state,
        name: this.translations(`states.${state.name}`)
      }))
    },
    getWarehouseName (warehouseId) {
      const warehouse = this.master_mywarehouses.find((item) => item.id === Number(warehouseId))
      return warehouse ? warehouse.name : '-------------'
    },
    refresh (id) { // number-container
      var element = document.querySelectorAll("[id='" + id + "']")
      for (var i = 0; i < element.length; i++) {
        let $this = $(element[i])
        $this.val(Number($this.val())) // TO NUMBER
        $this.next().text((+$this.val()).toLocaleString()) // REFRESH
      }
    },
    numbers (index, target) {
      this.replacementDetails[index][target] = this.replacementDetails[index][target].toString().replace(/[^0-9.-]/g, '')
    },
    async getVatRate () { // VAT
      try {
        let result = await this.$http.post(this.$api_url.vat_rate)
        console.log(JSON.stringify(result.data))
        if (result.data.status === true) {
          this.vatRate = result.data.vat_rate
          this.restoreTax()
        } else {
          this.$toastr.error('消費税率が取得できませんでした。', 'エラー')
          this.taxIncluded = false
          this.$refs['defaultCheckTax'].disabled = true
        }
      } catch (error) {
        console.log('NewEstimates:getVatRate:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },
    restoreTax () { // VAT (rename *****)
      this.taxIncluded = this.$storage.get('NewReplacement.taxIncluded', this.taxIncluded) ? this.$storage.get('NewEstimates.taxIncluded', this.taxIncluded) : false
      console.log(this.taxIncluded)
    },
    toggleTax () { // VAT (rename *****)
      this.$storage.set('NewReplacement.taxIncluded', this.taxIncluded)
      console.log(this.taxIncluded)
    },
    toVatFormat (target, noData = null, taxIncluded = null, vatRate = null) { // VAT OUTPUT
      if (target) {
        taxIncluded = taxIncluded === null ? this.taxIncluded : taxIncluded
        vatRate = vatRate === null ? Number(this.vatRate) : Number(vatRate)
        let tax = Math.round(target * (100 + vatRate) / 100)
        if (!taxIncluded) {
          return `${Number(target).toLocaleString()} (${Number(tax).toLocaleString()})`
        } else {
          return `${Number(tax).toLocaleString()} (${Number(target).toLocaleString()})`
        }
      } else if (noData !== null) {
        return noData
      } else {
        return '0'
      }
    },
    noVatFormat (target, noData = null) { // VAT OUTPUT
      if (target) {
        return Number(target).toLocaleString()
      } else if (noData !== null) {
        return noData
      } else {
        return ''
      }
    },
    filterTax (target, taxIncluded = null, vatRate = null) { // VAT INPUT
      target = target || 0
      taxIncluded = taxIncluded === null ? this.taxIncluded : taxIncluded
      vatRate = vatRate === null ? Number(this.vatRate) : Number(vatRate)
      if (!taxIncluded) {
        return target
      } else {
        let noTax = Math.round(target / ((100 + vatRate) / 100))
        return noTax
      }
    },

    openAddDetailModal () {
      this.isLoading = true
      this.getProducts()
    },
    setEmptyData () {
      this.replacementInfo = {}
      this.replacementDetails = []
      this.tempInfo = {}
      this.tempDetail = []
      this.warehouses = []
      this.stores = []
      this.bill_to = []
      this.delivery_destinations = []
      this.products = []
    },

    isNewReplacement () {
      return this.$route.name === 'new-replacement'
    },

    getGrandTotal () {
      this.grandTotalUnitPrice = 0
      this.grandTotalDebt = 0
      this.tempDetail.forEach(item => {
        this.grandTotalUnitPrice += item.unit_price * item.quantity
        if (item.replacement_status_id === 1) {
          this.grandTotalDebt += this.getRetrunPropsByItemNo(this.products, item.item_no, 'row_price') * item.quantity
        }
      })
    },

    setReplacementDate () {
      this.replacementInfo.processed_at = this.$invoiceTools.getCurrentDate()
      this.tempInfo.processed_at = this.$invoiceTools.getCurrentDate()
    },

    popoverButtons () {
      window.$("button[data-toggle='popover-x']").each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },

    /**
     * @param field : sales information props
     * @param value : value
     * @param ref   : reference trigger
     */
    updateField (field, value, ref, propToUpdate) {
      let $this = this
      let val = ''
      console.log(field, value, ref, propToUpdate)
      const rg = /^\s+$/
      if (!value || value === '-' || value === '' || rg.test(value) === true || typeof value === 'undefined') {
        if (field === 'estimated_at') {
          this.$refs[ref].innerText = '--------------'
        } else {
          this.$refs[ref].innerText = '--------------'
        }
        val = ''
      } else if (field === 'processed_at') {
        const x = /-/gi
        this.$refs[ref].innerText = value.replace(x, '/')
        val = value.replace(x, '/')
      } else if (field === 'warehouses_id') {
        this.master_mywarehouses.forEach(v => {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
            console.log('v.name: ' + v.name)
          }
        })
      } else if (field === 'store_id') {
        this.stores.forEach(v => {
          if (v.id === parseInt(value)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'bill_to_id') {
        this.bill_to.forEach(v => {
          if (v.id === parseInt(value)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'destinations_id') {
        val = 0 // DEFAULT // WARNING: DBがint型のため''ではエラーが発生する場合、該当selectのデフォルト値に0をセットし、比較対象が0件でも0になるよう初期値に0をセット
        this.destinations.forEach(function (v) {
          if (v.id === parseInt(value)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else {
        if (!propToUpdate) {
          this.$refs[ref].innerText = value
          val = value
        }
      }
      if (propToUpdate) {
        propToUpdate[field] = value
      } else {
        this.replacementInfo[field] = val
      }
      window.$('#popover-' + ref).popoverX('hide')
    },

    async getReplacementDetails (replacementId) {
      try {
        let returns = await this.$http.post(this.$api_url.replacement_details, { replacement_id: replacementId })
        let $data = this.$invoiceTools.prepareResult(returns.data, 'list', 'Replacement:getReplacementDetails')
        if ($data.success === true) {
          this.replacementInfo = $data.data.information
          this.replacementDetails = $data.data.details
        } else {
          this.$toastr.error($data.data, 'エラー')
        }
      } catch (error) {
        console.log('Replacement:getReplacementDetails:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    loadReplacementDetails () {
      setTimeout(() => {
        if (this.$route.query.id) {
          console.log('$route:query: ', this.$route.query)
          this.getReplacementDetails(this.$route.query.id)
          this.tempInfo = this.testData.testReplacementDetails.information
          this.tempDetail = this.testData.testReplacementDetails.details

          this.replacementInfo = this.testData.testReplacementDetails.information
          this.replacementDetails = this.testData.testReplacementDetails.details
          if (this.replacementInfo.warehouse) {
            this.tempInfo.warehouses_id = this.$invoiceTools.getObjPropsByKey(this.warehouses, 'name', this.replacementInfo.warehouse, 'id')
          }
          if (this.replacementInfo.store) {
            this.tempInfo.store_id = this.$invoiceTools.getObjPropsByKey(this.stores, 'name', this.replacementInfo.store, 'id')
          }
          if (this.replacementInfo.bill_to) {
            this.tempInfo.bill_to_id = this.$invoiceTools.getObjPropsByKey(this.bill_to, 'name', this.replacementInfo.bill_to, 'id')
          }
          if (this.replacementInfo.destination) {
          }
        } else {
          this.$router.replace('archive-replacement')
        }
      }, 3000)
    },

    deleteDetail (i) {
      this.replacementDetails.splice(i, 1)
    },

    /**
     * field/column: 納品先
     * api: /orders/destination_list
     */
    async getDestinationList () {
      try {
        let destinations = await this.$http.post(
          this.$api_url.order_destination_list
        )
        let $data = this.$invoiceTools.prepareResult(destinations.data, 'list')
        console.log('NewReplacement:getDestinationList: ', $data)
        if ($data.success === true) {
          this.delivery_destinations = $data.data
        } else {
          this.$toastr.error($data.data, 'エラー')
        }
      } catch (error) {
        console.log('NewReplacement:getDestinationList:catch(error): ', error)
        this.$toastr.error(
          'エラーのため失敗しました。ご確認後、再試行してください。',
          'エラー'
        )
      }
    },

    /**
     * field/column: 請求先
     * api: /bill_to/list
     */
    async getBillToList () {
      try {
        let billToList = await this.$http.post(this.$api_url.bill_to_list)
        let $data = this.$invoiceTools.prepareResult(billToList.data, 'list')
        console.log('NewReplacement:getBillToList: ', $data)
        if ($data.success === true) {
          this.bill_to = $data.data
        } else {
          this.$toastr.error($data.data, 'エラー')
        }
      } catch (error) {
        console.log('NewReplacement:getBillToList:catch(error): ', error)
        this.$toastr.error(
          'エラーのため失敗しました。ご確認後、再試行してください。',
          'エラー'
        )
      }
    },
    async listDestinations () {
      try {
        let cList = await this.$http.post(
          this.$api_url.destinations_list,
          { clients_id: this.tempInfo.bill_to_id }
        )
        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'NewReplacement:listDestinations')
        if ($data.success === true) {
          this.destinations = $data.data
        } else {
          this.destinations = [{ id: 0, name: 'No record.' }]
          this.$toastr.error($data.data, 'エラー')
        }
      } catch (error) {
        console.log('NewReplacement:listDestinations:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },
    async getSequence () {
      try {
        let result = await this.$http.post(this.$api_url.replacement_sequence)
        if (result.data.status === true) {
          this.tempInfo.reference_number = result.data.sequence
          this.replacementInfo.reference_number = result.data.sequence
          this.$refs['info02'].innerText = result.data.sequence
          this.$refs['input-info02'].value = result.data.sequence
        }
      } catch (error) {
        console.log('NewReplacement:getSequence:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },
    /**
     * field/column: 倉庫
     * api: /warehouse/list
     */
    // async getWarehouseList () {
    //   try {
    //     let warehouseList = await this.$http.post(this.$api_url.warehouse_list)
    //     let $data = this.$invoiceTools.prepareResult(
    //       warehouseList.data,
    //       'list'
    //     )
    //     console.log('NewReturn:getBillToList: ', $data)
    //     if ($data.success === true) {
    //       this.warehouses = $data.data
    //     } else {
    //       this.$toastr.error($data.data, 'エラー')
    //     }
    //   } catch (error) {
    //     console.log('NewReturn:getBillToList:catch(error): ', error)
    //     this.$toastr.error(
    //       'エラーのため失敗しました。ご確認後、再試行してください。',
    //       'エラー'
    //     )
    //   }
    // },

    async getProducts () {
      try {
        let params = {}
        let products = await this.$http.post(this.$api_url.replacement_get_products, params)
        let $data = this.$invoiceTools.prepareResult(products.data, 'list', 'NewReplacement:getProducts')
        if ($data.success === true) {
          this.products = $data.data
          this.$refs.openAddDetailModal.click() // 成功時にモーダル表示
        } else {
          this.$toastr.error($data.data, '処理失敗')
        }
      } catch (error) {
        console.log('NewReplacement:getProducts:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      } finally {
        this.isLoading = false
      }
    },

    getRetrunPropsById (selection, id, name) {
      let ret = ''
      selection.forEach((val, i) => {
        if (val.id === id) {
          ret = val[name]
        }
      })
      return ret
    },
    getRetrunPropsByItemNo (selection, itemNo, name) {
      let ret = ''
      selection.forEach((val, i) => {
        if (val.item_no === itemNo) {
          ret = val[name]
        }
      })
      return ret
    },

    async addReplacement () {
      try {
        if (this.replacementDetails.length < 1) {
          this.$toastr.warning('詳細行を入力してください。')
          return
        }
        this.replacementDetails.forEach(detail => {
          if (detail.from_warehouse) {
            detail.from_warehouse_id = detail.from_warehouse.id
          }
        })
        this.isLoading = true
        const params = {
          information: this.replacementInfo,
          details: this.replacementDetails
        }
        console.log(JSON.stringify(params)) // DEBUG
        let addReplacement = await this.$http.post(this.$api_url.replacement_add, params)
        let data = this.$invoiceTools.prepareResult(addReplacement.data, 'list', 'NewReplacement:addReplacement')
        if (data.success === true) {
          this.$toastr.success('保存に成功しました。', 'Success')
          this.$router.replace('/single-replacement?replacement_id=' + addReplacement.data.id)
        } else {
          this.$toastr.error(data.data, 'エラー')
        }
        setTimeout(() => { this.isLoading = false }, 1000)
      } catch (error) {
        console.log('NewReplacement:addReplacement:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    getOperationStatus (detail) {
      if (detail.replacement_status_id) {
        let statusName = this.$invoiceTools.getObjPropsById(this.replacement_statuses, detail.replacement_status_id, 'name')
        let bClass = ''
        let operation = ''
        switch (statusName) {
          case '新品':
            bClass = 'btn-primary btn-sm'
            operation = '在庫に移動'
            break
          case '相殺待ち':
          case '代替待ち':
            bClass = 'btn-danger btn-sm'
            operation = '完了'
            break
          case '破棄待ち':
            bClass = 'btn-danger btn-sm'
            operation = '破棄'
            break
        }
        if (operation) {
          return '<button class="btn ' + bClass + '">' + operation + '</button>'
        }
      }
      return '<p>&nbsp;</p>'
    }
  }
}
</script>
